// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".small-title-top[data-v-44ad2817]{padding-top:50px;display:flex;justify-content:center;align-items:center;padding-bottom:45px}.small-title[data-v-44ad2817]{color:#333;font-weight:bold;font-size:22px}.line[data-v-44ad2817]{width:14px;height:5px;background:#665eff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
